const medicineProductEn = {
  breadcrumbs: {
    home: 'Home',
    medicineBazar: 'Medicine Bazar'
  },
  loading: 'Loading...',
  labels: {
    prescriptionRequired: 'Prescription Required',
    reviewsSuffix: 'reviews',
    deliveryPrefix: 'Delivery:',
    minOrderPrefix: 'Min Order:',
    perUnitPrefix: 'Per',
    expiry: 'Expiry:',
    stock: 'Stock:',
    inStock: 'In Stock',
    outOfStock: 'Out of Stock',
    availableUnitsSuffix: 'available',
    selectQuantity: 'Select Quantity:',
    unitLabel: 'Unit',
    unitStrip: 'Strip',
    unitBox: 'Box',
    unitTablet: 'Tablet',
    unitBottle: 'Bottle',
    unitVial: 'Vial',
    unitAmpule: 'Ampule',
    unitTube: 'Tube',
    unitSachet: 'Sachet',
    unitInhaler: 'Inhaler',
    perUnitNotePrefix: '* Per',
    totalAmountPrefix: 'Total:',
    addToCart: 'Add to Cart',
    wishlistAria: 'Add to wishlist',
    shareAria: 'Share',
    descriptionTab: 'Description',
    specsTab: 'Specifications',
    reviewsTab: 'Reviews',
    productDescriptionTitle: 'Medicine Description',
    productSpecsTitle: 'Medicine Specifications',
    customerReviewsTitle: 'Customer Reviews',
    relatedTitle: 'Related Medicines',
  },
  messages: {
    addedToCart: 'added to cart!',
    orderInfo: 'All medicines are supplied from licensed pharmacies...'
  }
};

export default medicineProductEn;


